import { Flex, Box, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookSparkles } from '@fortawesome/pro-regular-svg-icons';
import { faFileLines } from '@fortawesome/pro-light-svg-icons';
import { OutlineCard } from '@morressier/alembic';

export const NoRecordFound = ({ title, subTitle }: { title: string, subTitle: string }) => {
  return (
    <Flex flexDirection="column" gap={8} textAlign="center">
      <Box bgColor="neutralSecondaryFill" padding={8}>
        <FontAwesomeIcon icon={faFileLines} fontSize={40} />
      </Box>
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingTitle">{title}</Text>
        <Text textStyle="textBody" paddingX={2}>
          {subTitle}
        </Text>
      </Flex>
    </Flex>
  );
}


const NoReviewsFound = () => {
  return (
    
      <OutlineCard borderless padding={4} width="100%">
        <Flex flexDirection="column" gap={8} textAlign="center">
      <Box bgColor="neutralSecondaryFill" padding={8}>
        <FontAwesomeIcon icon={faBookSparkles} fontSize={40} />
      </Box>
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingTitle">No Reviews Found</Text>
        <Text textStyle="textBody" paddingX={2}>
          Reviews will appear here after you accept invitations and begin
          reviewing submissions.
        </Text>
      </Flex>
      </Flex>
      </OutlineCard>
  );
};

export default NoReviewsFound;